import { ActivatedRouteSnapshot, Router, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { inject } from '@angular/core';
import { AccessControlRole, LogoutComponent } from '@lib-ui';
import { tap } from 'rxjs/operators';
import { AccessControlService } from '@lib-ui/lib/services/access-control.service';

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'jobs',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [MsalGuard],
    canActivateChild: [
      MsalGuard,
      (next: ActivatedRouteSnapshot) => {
        const router = inject(Router);
        return inject(AccessControlService).hasAccess(next).pipe(
          tap((hasAccess) => {
            if (!hasAccess) {
              router.navigate(['/']);
            }
          }),
        );
      },
    ],
    data: { roles: [AccessControlRole.Admin] },
    children: [
      {
        path: 'jobs',
        loadComponent: () => import('@portal/features/jobs/jobs.component').then(m => m.JobsComponent),
        data: {
          roles: [AccessControlRole.Admin, AccessControlRole.Disponent, AccessControlRole.KFM],
        },
      },
      {
        path: 'job',
        loadComponent: () => import('@portal/features/jobdetail/jobdetail.component').then(m => m.JobdetailComponent),
        data: {
          roles: [AccessControlRole.Admin, AccessControlRole.Disponent, AccessControlRole.KFM],
        },
      },
      {
        path: 'users',
        loadComponent: () => import('@portal/features/users/users.component').then(m => m.UsersComponent),
        data: { roles: [AccessControlRole.Admin] },
      },
      {
        path: 'teams',
        loadComponent: () => import('@portal/features/teams/teams.component').then(m => m.TeamsComponent),
        data: { roles: [AccessControlRole.Admin] },
      },
    ],
  },
  {
    path: 'logout',
    canActivate: [MsalGuard],
    canActivateChild: [MsalGuard],
    component: LogoutComponent,
  },
  {
    path: 'inviteaccepted',
    redirectTo: 'logout',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'jobs',
    pathMatch: 'full',
  },
];
